import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { TOrganizationProjectDimension } from "../types/projects";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";
import $api from "../api/axios";

export const GET_PROJECT_DIMENSIONS_KEY = "getProjectDimensions";

type TQueryOpts = Partial<UseQueryOptions<TOrganizationProjectDimension[], Error>>;

export function useProjectDimensions(options?: TQueryOpts, organizationId?: number) {
  const { currentOrganizationId } = useOrganizationStore();
  const effectiveOrganizationId = organizationId ?? currentOrganizationId;

  return useQuery({
    queryKey: [GET_PROJECT_DIMENSIONS_KEY, effectiveOrganizationId],
    queryFn: async () => {
      const { data } = await $api.get<{ data: TOrganizationProjectDimension[] }>(
        `/organizations/${effectiveOrganizationId}/project-dimensions`
      );
      return data.data;
    },
    enabled: effectiveOrganizationId > 0,
    ...options
  });
}
